export default {
    title:`Our mission`,
    html:`
<section class="page-content" >
	<h2 style="margin-bottom:20px">SEIZE LOVE, SPREAD JOY</h2>
	<div class="phone-text">
		<p>
– It’s often said that love makes the world go ‘round. As such, CrushPledge was created with the goal of connecting two people who come to realize their affections for each other—when they may not otherwise express these feelings openly—in a secure way that’s free of embarrassment and shame of rejection. Because we also believe that love is borne out of goodness, we wanted to help make the world a better place in the process. 
		</p>
	 </div>
	 <div style="margin-top:20px">
		<p> Become part of our journey. After all, this would make a great wedding speech about how you met your spouse. </p>
	 </div>
</section>
`
}


// WEBPACK FOOTER //
// ./assets/strings/why.js